import React, { useEffect } from 'react';
import {
  Container, Row, Col,
} from 'react-bootstrap';
import { useAppSelector } from '../app/hooks';
import { selectAddress } from '../features/address/addressSlice';
import { trackAddressRegister } from '../lib/analytics';

const formId = '16db8c63-2191-4c81-b6e8-e3f00d0864cb';

const ExpressInterest = () => {
  const addr = useAppSelector(selectAddress);

  // HubSpot forms report their lifecycle through window messages
  useEffect(() => {
    const onMessage = (e: MessageEvent) => {
      if (e.data?.type === 'hsFormCallback'
        && e.data?.eventName === 'onFormSubmitted'
        && e.data?.id === formId) {
        trackAddressRegister(addr);
      }
    };
    window.addEventListener('message', onMessage);
    return () => window.removeEventListener('message', onMessage);
  }, [addr]);

  useEffect(() => {
    const script = document.createElement('script');
    script.src = 'https://js.hsforms.net/forms/v2.js';
    document.body.appendChild(script);

    script.addEventListener('load', () => {
      // @ts-ignore
      if (window?.hbspt) {
        // @ts-ignore
        window?.hbspt.forms.create({
          portalId: '8498425',
          formId,
          target: '#hubspotForm',
          region: 'na1',
        });
      }
    });
  }, []);

  return (
    <Container>
      <Row className="px-2 py-5 justify-content-center">
        <Col xs md={6} id="hubspotForm" />
      </Row>
    </Container>
  );
};

export default ExpressInterest;
